module.exports = __webpack_public_path__ + "img/roth.2ec21b72.png";